// extracted by mini-css-extract-plugin
export default {"stats":"AnswerStat_stats__mzRjh","col":"AnswerStat_col__rdViq","param":"AnswerStat_param__9XUBz","paramEdit":"AnswerStat_paramEdit__bgET-"};